import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstructionStepperComponent } from '@core/components/instruction-stepper/instruction-stepper.component';
import { MediaButtonComponent } from '@core/components/ui-media-button/media-button.component';
import type { DirectConnectionsVoucher } from './direct-connections-voucher.interface';

@Component({
  selector: 'dcv-direct-connections-voucher',
  standalone: true,
  imports: [CommonModule, InstructionStepperComponent, MediaButtonComponent],
  templateUrl: './direct-connections-voucher.component.html',
  styleUrl: './direct-connections-voucher.component.scss',
})
export class DirectConnectionsVoucherComponent implements OnChanges {
  @Input({ required: true }) directConnectionsVoucherInput!: DirectConnectionsVoucher;
  @Input() color = 'primary';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['directConnectionsVoucherInput']) {
      this.directConnectionsVoucherInput = changes['directConnectionsVoucherInput'].currentValue;
    }
  }
}
